import React from 'react';
import { gray } from '../theme/colors';

function CheckboxChecked(props: React.SVGProps<SVGSVGElement>) {
  const { color = gray[600] } = props;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      {...props}
    >
      <rect
        x="1"
        y="1"
        width="16"
        height="16"
        rx="2"
        stroke="currentColor"
        fill="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M3.6001 8.9999L7.2001 12.5999L14.4001 5.3999"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
}

export default CheckboxChecked;
